// 供需审核list页权限
export const SUPPLY_DEMAND_LIST_PAGE_UUID =
  '0186433d-71fd-414e-bab4-bc7c442bacd6'
// 供需审核操作权限
export const SUPPLY_DEMAND_ACTION_UUID = 'ff8ff0ce-8181-48e5-b645-9f4c927ab495'
